var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrustly({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 236.5 50",
    style: {
      enableBackground: "new 0 0 236.5 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M78.9,39.7v-32H67.4V0h31.2v7.6H87.1v32h-8.2V39.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.3,39.7V10.9h7.6v4.6c1.8-3.9,4.1-4.6,6.6-4.6h2.9v7.7h-2.5c-3.6,0-6.8,2.1-6.8,8.4v12.7L97.3,39.7L97.3,39.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118,29.1V10.9h7.9v16.5c0,3.4,1.6,5.9,5,5.9c3.2,0,5.3-2.5,5.3-5.8V10.9h7.9v28.8h-7.5v-3.6c-1.9,2.9-4.7,4.3-8.3,4.3 C121.9,40.3,118,36,118,29.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.3,31.6l6.8-1.6c0.3,2.2,2.1,3.9,5.5,3.9c2.6,0,4.1-1.1,4.1-2.4c0-1.1-0.6-1.9-3.3-2.5l-4.5-1 c-5.7-1.3-8.2-3.9-8.2-8.8s4.1-8.9,11.7-8.9c8.1,0,11.4,4.9,11.7,8.1l-6.9,1.5c-0.3-1.7-1.6-3.5-5-3.5c-2.2,0-3.8,1-3.8,2.4 c0,1.2,0.8,1.9,2.2,2.2l6.6,1.5c5,1.1,7.3,4.1,7.3,8.4c0,4.6-3.6,9.3-11.9,9.3C150.6,40.2,147.7,34.7,147.3,31.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.8,39.7c-5.1,0-8.5-2.8-8.5-8.4V17.8h-4.8v-6.9h4.8V4.5l7.9-2.3v8.7h5.8v6.9h-5.8v12c0,2.1,1.1,2.9,3.2,2.9h3v6.9 L186.8,39.7L186.8,39.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.6,39.7V0h7.9v39.7H196.6L196.6,39.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.2,10.9h8.4l-12,39.1h-8.4l3.3-10.3h-4.3l-7.9-28.8h8.4l5.9,22.3L228.2,10.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,17.4h18.4V2.6l14.7,14.8L18.4,32.1v7.5h17.9V17.4h16.4V0H0V17.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrustly);
export default __webpack_public_path__ + "static/media/Trustly.29544e39df229f154080502ae9d992ba.svg";
export { ForwardRef as ReactComponent };